import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, X, Search } from 'lucide-react';
import './SearchableSelect.css';


export default function SearchableSelect({ value, options = [], onChange, placeholder = 'Выберите...', emptyLabel = '— не выбрано —', onSearch }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  useEffect(() => {
    if (open && inputRef.current) inputRef.current.focus();
  }, [open]);

  useEffect(() => {
    if (onSearch) onSearch(search);
  }, [search]);

  const selected = options.find(o => o.value === value);
  const filtered = onSearch
    ? options
    : (search
      ? options.filter(o => {
          const s = search.toLowerCase();
          return (o.label || '').toLowerCase().includes(s) || (o.sublabel || '').toLowerCase().includes(s) || (o.value || '').toLowerCase().includes(s);
        })
      : options);

  return (
    <div className="ss-wrapper" ref={ref}>
      <div className="ss-trigger" onClick={() => setOpen(!open)}>
        <div className="ss-value">
          {selected ? (
            <>
              <span>{selected.label}</span>
              {selected.sublabel && <span className="ss-sublabel">{selected.sublabel}</span>}
            </>
          ) : (
            <span className="ss-placeholder">{placeholder}</span>
          )}
        </div>
        <div className="ss-actions">
          {selected && (
            <button type="button" className="ss-clear" onClick={(e) => { e.stopPropagation(); onChange(''); setSearch(''); }}>
              <X size={14} />
            </button>
          )}
          <ChevronDown size={14} className={`ss-chevron ${open ? 'open' : ''}`} />
        </div>
      </div>

      {open && (
        <div className="ss-dropdown">
          <div className="ss-search">
            <Search size={13} className="ss-search-icon" />
            <input
              ref={inputRef}
              type="text"
              className="ss-search-input"
              placeholder="Поиск..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              onClick={e => e.stopPropagation()}
            />
          </div>
          <div className="ss-options">
            <div className="ss-option ss-option-empty" onClick={() => { onChange(''); setOpen(false); setSearch(''); }}>
              {emptyLabel}
            </div>
            {filtered.length === 0 ? (
              <div className="ss-no-results">Ничего не найдено</div>
            ) : (
              filtered.map(o => (
                <div
                  key={o.value}
                  className={`ss-option ${o.value === value ? 'selected' : ''}`}
                  onClick={() => { onChange(o.value); setOpen(false); setSearch(''); }}
                >
                  <div className="ss-option-label">{o.label}</div>
                  {o.sublabel && <div className="ss-option-sublabel">{o.sublabel}</div>}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}